module.exports = __webpack_public_path__ + "static/hero1-d19386b3feb583e3f1108e0d3dd457f3.jpg";